import { Box, Button, Card, Container, Grid, MenuItem, TextField, Typography } from '@mui/material'
import HeaderSession from '../../../../../utils/headerSession'
import RegisterAccess from '../../../../../utils/registerAccess'
import { PictureAsPdfOutlined } from '@material-ui/icons'
import apiCNP from '../../../../../services/apiCNP';
import { useEffect, useState } from 'react';
import { CountryDropdown } from 'react-country-region-selector';
import api from '../../../../../services/api';
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { RelatorioImportPDF } from './relatorioImportPDF';

export default function RelatorioImportacao() {
  const [selectedCountry, setSelectedCountry] = useState('');
  const [paisImport, setPaisImport] = useState('');
  const [graficoPorProduto, setGraficoPorProduto] = useState([]);
  const [selectedPontoEntrada, setSelectedPontoEntrada] = useState('');
  const [graficoPorPontoEntrada, setGraficoPorPontoEntrada] = useState([]);
  const [graficoImportador, setGraficoImportador] = useState([]);
  const [graficoMoedas, setGraficoMoedas] = useState([]);
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [ano, setAno] = useState("");
  const [importador, setImportador] = useState([]);
  const [importadorSelecionado, setImportadorSelecionado] = useState('');
  const [importadorId, setImportadorId] = useState('');
  const [status, setStatus] = useState('');


  useEffect(() => {
    let todos = [];
    let pagina = 1;

    const carregarTodos = async () => {
      let continuar = true;

      while (continuar) {
        const res = await api.get(`/estabelecimentos?tipoId=660176d0075c22f85a87841f&page=${pagina}`);
        console.log(res)
        const dados = res.data.estabelecimentos || [];
        todos = [...todos, ...dados];
        continuar = res.data.hasNextPage;
        pagina = res.data.nextPage
      }
      
      todos.sort((a, b) => a.nome.localeCompare(b.nome, 'pt', { sensitivity: 'base' }));
      setImportador(todos);
    };

    carregarTodos();
  }, []);

  useEffect(() => {
    api.get(`/solicitacao-importacao/estatistica/pais-origem?paisOrigem=${selectedCountry}&dataInicial=${dataInicio}&dataFinal=${dataFim}&ano=${ano}&importador=${importadorSelecionado}&status=${status}`)
      .then((res) => {
        const resultado = res.data?.solicitacaoImportacaos || [];

        const dadosFormatados = resultado.map((item) => ({
          nome: item.paisOrigem,
          solicitacoes: item.solicitacoes
        }));
        setPaisImport(dadosFormatados);
      })
      .catch((err) => console.log(err))

    api.get(`/solicitacao-importacao/estatistica/productos?paisOrigem=${selectedCountry}&dataInicial=${dataInicio}&dataFinal=${dataFim}&ano=${ano}&importador=${importadorSelecionado}&status=${status}`)
      .then((res) => {
        const resultado = res.data?.solicitacaoImportacaos || [];
        console.log(resultado)
        const dadosFormatados = resultado.map((item) => ({
          nome: item.producto?.nome ?? 'Produto desconhecido',
          quantidade: item.producto?.quantidade ?? 0,
          valorTotal: item.producto?.valorTotalKZ ?? 0
        }));

        setGraficoPorProduto(dadosFormatados);
      })
      .catch((err) => console.log(err))
  }, [selectedCountry, dataInicio, dataFim, ano, importadorSelecionado, status])

  useEffect(() => {
    api
      .get(`/declaracao-desalfandegamento/estatistica/ponto-entrada?pontoEntrada=${selectedPontoEntrada}&ano=${ano}&dataInicial=${dataInicio}&dataFinal=${dataFim}&paisOrigem=${selectedCountry}&importadorId=${importadorId}&status=${status}`)
      .then((res) => {
        const resultado = res.data?.declararacaoDesalfandegamentos || [];

        const dadosFormatados = resultado.map((item) => ({
          nome: item.pontoEntrada,
          solicitacoes: item.solicitacoes
        }));

        setGraficoPorPontoEntrada(dadosFormatados);
      })
      .catch((err) => console.error(err));
  }, [selectedPontoEntrada, selectedCountry, dataInicio, dataFim, ano, importadorId, status]);

  useEffect(() => {
    api
      .get(`/declaracao-desalfandegamento/estatistica/emolumento?dataInicial=${dataInicio}&dataFinal=${dataFim}&ano=${ano}&paisOrigem=${selectedCountry}&importadorId=${importadorId}&status=${status}`)
      .then((res) => {
        // console.log(res)
        // const resultado = res.data?.declararacaoDesalfandegamentos || [];

        // const dadosFormatados = resultado.map((item) => ({
        //   nome: item.pontoEntrada,
        //   solicitacoes: item.solicitacoes
        // }));

        // setGraficoPorPontoEntrada(dadosFormatados);
      })
      .catch((err) => console.error(err));
  }, [selectedCountry, dataInicio, dataFim, ano, importadorId, status]);

  useEffect(() => {
    api
      .get(`/declaracao-desalfandegamento/estatistica/importador?dataInicial=${dataInicio}&dataFinal=${dataFim}&paisOrigem=${selectedCountry}&ano=${ano}&importadorId=${importadorId}&status=${status}`)
      .then((res) => {
        const resultado = res.data?.declararacaoDesalfandegamentos || [];

        const dadosFormatados = resultado.map((item) => ({
          nome: item.importador.nome,
          solicitacoes: item.solicitacoes
        }));

        setGraficoImportador(dadosFormatados);
      })
      .catch((err) => console.error(err));
  }, [selectedCountry, dataInicio, dataFim, ano, importadorId, status]);

  useEffect(() => {
    api
      .get(`/solicitacao-importacao/estatistica/productos-moeada?dataInicial=${dataInicio}&dataFinal=${dataFim}&paisOrigem=${selectedCountry}&ano=${ano}&importador=${importadorSelecionado}&status=${status}`)
      .then((res) => {
        const resultado = res.data?.solicitacaoImportacaos || [];

        const dadosFormatados = resultado.map((item) => ({
          moeda: item.producto,
          solicitacoes: item.solicitacoes
        }));

        setGraficoMoedas(dadosFormatados);
      })
      .catch((err) => console.error(err));
  }, [selectedCountry, dataInicio, dataFim, ano, importadorSelecionado, status]);

  return (
    <Container style={{ maxWidth: '100vw', padding: 8 }}>
      <RegisterAccess page={'Relatório de Atividades Geral'} />
      <HeaderSession title={'RELATORIOS SOBRE IMPORTAÇÃO & DESALFANDEGAMENTO'} />
      <br />

      <Box>
        <div style={{ display: "flex", alignItems: 'center', gap: '10px' }}>
          <Grid>
            <CountryDropdown
              style={{
                color: '#000',
                border: '1px solid #e1e1e1',
                backgroundColor: 'transparent',
                height: '90%',
                padding: '11px',
                borderRadius: '4px',
                width: '200px'
              }}
              value={selectedCountry}
              onChange={(pais) => setSelectedCountry(pais)}
              defaultOptionLabel="Pais de Origem"
            />
          </Grid>
          <Grid style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
            <TextField
              style={{ width: 200 }}
              type="date"
              fullWidth
              label="Data Inicial"
              size="small"
              name="dataInicial"
              variant="outlined"
              onChange={(e) => setDataInicio(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              style={{ width: 200 }}
              type="date"
              fullWidth
              label="Data Final"
              size="small"
              name="dataFinal"
              variant="outlined"
              onChange={(e) => setDataFim(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              style={{ width: 200 }}
              select
              fullWidth
              label="Ano"
              size="small"
              name="ano"
              variant="outlined"
              value={ano}
              onChange={(e) => setAno(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    style: {
                      maxHeight: 300, // para scroll
                    },
                  },
                },
                displayEmpty: true,
              }}
            >
              <MenuItem value="" disabled style={{ padding: '8px' }}>
                Selecione o ano
              </MenuItem>
              {Array.from({ length: 50 }, (_, i) => {
                const year = new Date().getFullYear() - i;
                return (
                  <MenuItem key={year} value={year} style={{ display: 'block', padding: '8px' }}>
                    {year}
                  </MenuItem>
                );
              })}
            </TextField>

            <TextField
              style={{ width: 200 }}
              select
              fullWidth
              label="Importador"
              size="small"
              value={importadorSelecionado}
              onChange={(e) => setImportadorSelecionado(e.target.value)}
            >
              <MenuItem value="" disabled style={{ padding: '8px' }} >Selecionar Importador</MenuItem>
              {importador.map((item) => (
                <MenuItem key={item._id} value={item.nome} onClick={() => setImportadorId(item._id)}>
                  {item.nome}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              style={{ width: 200 }}
              select
              fullWidth
              label="Estado"
              size="small"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <MenuItem value="" disabled style={{ padding: '8px' }} >Estado</MenuItem>
              <MenuItem key={'aprovado'} value={'Aprovado'}>Aprovado</MenuItem>
              <MenuItem key={'reprovado'} value={'Reprovado'}>Reprovado</MenuItem>
            </TextField>

          </Grid>

          <Button style={{ backgroundColor: '#85287e', padding: 7, color: '#fff', borderRadius: '4px' }} variant="contained" onClick={() => RelatorioImportPDF({ ...graficoPorProduto, produtos: graficoPorProduto, paisOrigem: paisImport })} >
            {/* <PictureAsPdfOutlined sx={{ mr: 1 }} /> */}
            Gerar Pdf
          </Button>
        </div>

        <div style={{ marginTop: '10px' }}>
          <Box sx={{ width: '100%', height: 400, mt: 4 }}>
            <Typography variant="h6" sx={{ mb: 2, fontSize: 14 }} style={{ textTransform: 'uppercase' }}> Solicitações por País de Origem</Typography>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={paisImport}>
                <XAxis dataKey="nome" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="solicitacoes" fill="#8884d8" name="Solicitações" />
              </BarChart>
            </ResponsiveContainer>

            <Typography variant="h6" sx={{ mb: 2, fontSize: 14 }} style={{ textTransform: 'uppercase' }}>
              Solicitações por Produtos Mais Importados
            </Typography>

            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={graficoPorProduto}>
                <XAxis dataKey="nome" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="quantidade" fill="#8884d8" name="Quantidade" />
                {/* ou use valorTotal se preferir: */}
                {/* <Bar dataKey="valorTotal" fill="#82ca9d" name="Valor Total (KZ)" /> */}
              </BarChart>
            </ResponsiveContainer>

            <Typography variant="h6" sx={{ mb: 2, fontSize: 14 }} style={{ textTransform: 'uppercase' }}>
              Solicitações por Pontos de Entrada
            </Typography>

            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={graficoPorPontoEntrada}>
                <XAxis dataKey="nome" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="solicitacoes" fill="#8884d8" name="Nº de Entradas" />
              </BarChart>
            </ResponsiveContainer>

            <Typography variant="h6" sx={{ mb: 2, fontSize: 14 }} style={{ textTransform: 'uppercase' }}>
              Solicitações por Importador
            </Typography>

            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={graficoImportador}>
                <XAxis dataKey="nome" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="solicitacoes" fill="#8884d8" name="Importador" />
              </BarChart>
            </ResponsiveContainer>


            <Typography variant="h6" sx={{ mb: 2, fontSize: 14 }} style={{ textTransform: 'uppercase' }}>
              Solicitações por Moeda
            </Typography>

            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={graficoMoedas}>
                <XAxis dataKey="moeda" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="solicitacoes" fill="#8884d8" name="Nº de Solicitaçōes" />
              </BarChart>
            </ResponsiveContainer>
          </Box>


        </div>
      </Box>
    </Container>
  )
}
